import { Model, belongsTo, hasMany } from 'miragejs'

export default Model.extend({
  school: belongsTo(),
  students: hasMany(),
  schoolClasses: hasMany(),
  teacherSubscriptions: hasMany(),
})
